// extracted by mini-css-extract-plugin
module.exports = {"debug":"controls_debug__2A1rz","controls":"controls_controls__1KKqb"};